import { Button } from 'components/buttons';
import plus from 'assets/icons/commons/roundPlus.svg';

interface IAddNewUpdProps {
    toShowUpdForm: () => void;
}

function AddNewUpdBtn({
    toShowUpdForm,
}: IAddNewUpdProps) {

    return (
        <div className={`flex justify-end`}>
            <Button
                clickHandler={toShowUpdForm}
                appearance="primary"
                customClassName="button-add btn-sm"
            >
                <div className="flex justify-around w-[150px] items-center">
                    <img src={plus} className="w-4 h-4" />
                    <div>Добавить УПД</div>
                </div>
            </Button>
        </div>

    );
}

export default AddNewUpdBtn;
